import {Result} from "antd";
import {useTranslation} from "react-i18next";


const Page_505 = () => {
    const {t} = useTranslation();
    return(
        <>
            <Result
                status="500"
                title="500"
                subTitle={t('500')}

            />
        </>
    )
}

export default Page_505;